import { Footer } from '../components/Footer';
import { BlurbLogoIcon } from '../icons/icon-def/BlurbLogoIcon';
import { Outlet } from 'react-router-dom';

export const CartLayout = () => {
  return (
    <div className="flex flex-col w-full md:pb-8">
      <div className="w-full bg-white">
        <div className="sm:w-[53px] w-[40px] pt-5">
          <BlurbLogoIcon />
        </div>
      </div>
      <Outlet />
      <Footer />
    </div>
  );
};
